import React, { useEffect, useState } from 'react';
import { fetchDeviceCategories } from '../../redux/api';
import { su } from './stockUi';

const DeviceCategorySelect = ({
  valueId = '',
  onChange,
  className = '',
}) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await fetchDeviceCategories();
        setCategories(Array.isArray(response?.data) ? response.data : []);
      } catch (error) {
        setCategories([]);
      }
    };
    load();
  }, []);

  const handleChange = (e) => {
    const id = e.target.value;
    const selected = categories.find((cat) => String(cat.id || cat._id) === String(id));
    onChange?.({
      id: id || '',
      name: selected?.name || '',
    });
  };

  const selectedValue =
    valueId ||
    '';

  return (
    <select value={selectedValue} onChange={handleChange} className={`${su.input} ${className}`}>
      <option value="">Izaberi kategoriju</option>
      {categories.map((category) => {
        const id = category.id || category._id;
        return (
          <option key={id} value={id}>
            {category.name}
          </option>
        );
      })}
    </select>
  );
};

export default DeviceCategorySelect;
